import { StyleSheet, Text, View } from '@react-pdf/renderer';

export const stylesDocPdf = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    paddingBottom: '30pt',
  },
  body: {
    height: '50%',
  },
  section: {
    margin: 40,
  },
  borderCell: {
    borderStyle: 'solid',
    borderColor: 'black',
    borderWidth: 1,
    fontSize: 8,
    paddingHorizontal: 5,
    paddingVertical: 2,
  },
});

export const stylesPdf = StyleSheet.create({
  section: {
    flexDirection: 'column',
    flex: 1,
  },
  cell: {
    borderStyle: 'solid',
    borderColor: 'black',
    borderWidth: 1,
  },
  title: {
    fontFamily: 'OpenSans',
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 9,
    paddingHorizontal: 3,
    marginBottom: 2,
  },
  text: {
    fontFamily: 'OpenSans',
    textAlign: 'center',
    fontSize: 9,
    paddingHorizontal: 2,
    marginVertical: 1,
  },
  logo: {
    width: 30,
    height: 30,
  },
  row: {
    flexDirection: 'row',
  },
});

export const cellPdf = ({
  value,
  width,
  textAlign,
  fontSize,
  bold = false,
  stylesText = {},
  stylesCell = {},
  color,
  borderAll = false,
}) => (
  <View
    style={[
      stylesPdf.cell,
      {
        borderAll,
        borderTopWidth: 0,
        borderRightWidth: 0,
        width,
        backgroundColor: color,
      },
      stylesCell,
    ]}
  >
    {value && (
      <Text
        style={[
          stylesPdf.text,
          {
            textAlign,
            fontSize,
            fontWeight: bold ? 'bold' : 'normal',
          },
          stylesText,
        ]}
      >
        {value}
      </Text>
    )}
  </View>
);
